import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    padding: 3px 10px 3px 10px;
    justify-content: center;
    align-items: center;
    border-radius: 7px;
    background: var(--Basic-900);
    color: var(--Basic-200);
    font-size: 13px;
    font-weight: 400;
`